import { render, staticRenderFns } from "./EditQuotation.vue?vue&type=template&id=37b2ee4a&scoped=true&"
import script from "./EditQuotation.vue?vue&type=script&lang=js&"
export * from "./EditQuotation.vue?vue&type=script&lang=js&"
import style0 from "./EditQuotation.vue?vue&type=style&index=0&id=37b2ee4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2ee4a",
  null
  
)

export default component.exports